module.exports = __webpack_public_path__ + "img/login-servidoresmunicipales.9ad12651.svg";